import MaplibreTextStampControl from "./MaplibreTextStampControl";

class MaplibreTextControl extends MaplibreTextStampControl {
    constructor(name, extraText) {
        super();
        this._interactiveLayer = name;
        this._sourceName = name;
        this.extraText = extraText || "";
    }

    _initLayers() {
        this._map.addSource(this._sourceName, {
            type: "geojson",
            data: this.data
        });
        this._map.addLayer({
            id: this._interactiveLayer,
            type: "symbol",
            source: this._sourceName,
            layout: {
                "text-field": `${this.extraText}{text}`,
                "text-size": 28,
                "text-line-height": 0.9
            },
            paint: {
                "text-halo-color": "#ffffff",
                "text-halo-width": 2,
                "text-halo-blur": 1
            }
        });
    }

    _initHandlers() {
        this._map.on("click", this._interactiveLayer, this._clicked.bind(this));
        super._initHandlers();
    }

    _clicked(e) {
        setTimeout(() => {
            const selectedFeatures = this._map.queryRenderedFeatures(e.point);
            if (selectedFeatures.length) {
                const feature = this.data.features.find((item) => item.id === selectedFeatures[0].id);
                if (feature) {
                    const text = feature.properties.text;
                    let newText = prompt("Edit text", text);
                    if (newText !== null) {
                        feature.properties.text = newText;
                        this._updateData();
                    }
                }
            }
        }, 200);
    }
}

export default MaplibreTextControl;
